const SESSION_KEY = 'veilstream_session'
const LEGACY_SESSION_KEY = 'github_access_token'

export function getSessionToken(): string | null {
  if (typeof localStorage === 'undefined') return null
  return localStorage.getItem(SESSION_KEY) || localStorage.getItem(LEGACY_SESSION_KEY)
}

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_KEY, token)
  // Dual-write so leftover readers of the legacy key keep working during cutover.
  localStorage.setItem(LEGACY_SESSION_KEY, token)
}

export function clearSessionToken(): void {
  localStorage.removeItem(SESSION_KEY)
  localStorage.removeItem(LEGACY_SESSION_KEY)
}
